import React, { memo, useState, useEffect } from "react";
import { RequestBookingService } from "../../services/RequestBookingService";
import { getCarModelByName } from "../../services/carModelService";
import { Booking, Payment } from '../../models/booking'
import { CarModel } from '../../models/CarModel'

interface EstimatedFareProps {
  booking: Booking;
}

const EstimatedFare: React.FC<EstimatedFareProps> = ({ booking }) => {
  const [bookingDetails, setBookingDetails] = useState<Booking>();
  const [selectedCarModel, setSelectedCarModel] = useState<CarModel | null>()


  useEffect(() => {
    const fetchBookingDetails = async () => {
      const bookingDetails = await RequestBookingService.getRequestBooking().booking;
      const selectedModel = await getCarModelByName(booking.selectedCarModel)
      if (bookingDetails)
        setBookingDetails(bookingDetails);
      setSelectedCarModel(selectedModel)
    };

    fetchBookingDetails();
  }, [booking]);

  let discountType;

  if (bookingDetails?.status === "firstTimeBooking") {
    discountType = "FirstTimeBooking";
  } else if (bookingDetails?.status === "LastMinuteFare") {
    discountType = "LastMinuteFare";
  } else {
    discountType = "Online";
  }



  return (
    <div className="card w-100 mb-3 shadow-sm">
      <div className="card-body">
        <div className="row mb-2">
          <div className="col-6 text-start">
            <strong>Total Distance</strong>
          </div>
          <div className="col-6 text-end">
            <strong>
              {bookingDetails ? (bookingDetails.returnRide ? bookingDetails.payment?.extraKms + 150 * 2 : bookingDetails.payment?.extraKms + 150) : 0} Km
          </strong>
          </div>
        </div>

        <div className="row mb-1">
          <div className="col-8 text-start">Base Fare ({bookingDetails?.returnRide ? 300 : 150} km)</div>
          <div className="col-4 text-end">₹{bookingDetails?.payment?.baseFare}</div>
        </div>

        <div className="row mb-1">
          <div className="col-7 text-start">Extra Km  ({bookingDetails?.payment?.extraKms})</div>
          <div className="col-5 text-end">₹{bookingDetails?.payment?.extraKmCharges}</div>
        </div>

        <div className="row mb-1">
          <div className="col-6 text-start">GST (5%)</div>
          <div className="col-6 text-end">₹{bookingDetails?.payment?.gstFare}</div>
        </div>

        <div className="row mb-1">
          <div className="col-7 text-start">Toll (Expressway)</div>
          <div className="col-5 text-end">₹{bookingDetails?.payment?.toll}</div>
        </div>

        <div className="row mb-1">
          <div className="col-6 text-start">Parking</div>
          <div className="col-6 text-end">₹{bookingDetails?.payment?.parking}</div>
        </div>

        <div className="row mb-1">
          <div className="col-7 text-start text-success fw-bold">Discount ({discountType})</div>
          <div className="col-5 text-end text-success fw-bold">₹{bookingDetails?.payment?.discount}</div>
        </div>

        <div className="row mt-2">
          <div className="col-6 text-start text-success fw-bold">Estimated Fare</div>
          <div className="col-6 text-end text-success fw-bold">₹{bookingDetails?.payment?.totalFare}</div>
        </div>
      </div>
    </div>

  );
};

export default memo(EstimatedFare);
